import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { ApiWaveOutcomeCredit } from "@/generated/models/ApiWaveOutcomeCredit";
import { ApiWaveOutcomeType } from "@/generated/models/ApiWaveOutcomeType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faStar } from "@fortawesome/free-regular-svg-icons";
import { faAward } from "@fortawesome/free-solid-svg-icons";
interface WaveWinnersDropOutcomeProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropOutcome(t0) {
  const $ = _c(18);
  const {
    winner
  } = t0;
  const t1 = winner.awards;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== winner.awards) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const nicOutcomes = t1.filter(_temp).map(_temp2);
      const repOutcomes = winner.awards.filter(_temp3).map(_temp4);
      const manualOutcomes = winner.awards.filter(_temp5).map(_temp6);
      const haveOutcomes = nicOutcomes.length > 0 || repOutcomes.length > 0 || manualOutcomes.length > 0;
      if (!haveOutcomes) {
        t8 = null;
        break bb0;
      }
      t6 = "tw-flex tw-items-start tw-gap-2";
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <span className="tw-text-iron-500 tw-text-sm tw-font-medium">Outcome:</span>;
        $[8] = t7;
      } else {
        t7 = $[8];
      }
      t2 = "tw-flex tw-flex-wrap tw-gap-1.5";
      t3 = nicOutcomes.map(_temp7);
      t4 = repOutcomes.map(_temp8);
      t5 = manualOutcomes.map(_temp9);
    }
    $[0] = winner.awards;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t9 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t9) {
    t10 = <div className={t6}>{t7}{t9}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
function _temp9(outcome) {
  return <span key={`MANUAL-${outcome.description}`} className="tw-flex tw-gap-1.5"><FontAwesomeIcon icon={faAward} className="tw-size-3.5 tw-text-amber-300/70 tw-mt-1" /><span className="tw-text-sm tw-font-normal tw-text-amber-100/90">{outcome.description}</span></span>;
}
function _temp8(repOutcome) {
  return <span key={`REP-${repOutcome.category}-${repOutcome.value}`} className="tw-flex tw-gap-1.5"><FontAwesomeIcon icon={faStar} className="tw-size-3.5 tw-text-purple-300/70 tw-mt-1" /><span className="tw-text-sm tw-font-normal tw-text-iron-50">Rep</span><span className="tw-text-sm tw-font-normal tw-text-purple-200/90">{formatNumberWithCommas(repOutcome.value)}</span>{repOutcome.category && <><span className="tw-size-[2px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-400/70" /><span className="tw-text-sm tw-font-normal tw-text-purple-200/90">{repOutcome.category}</span></>}</span>;
}
function _temp7(nicOutcome) {
  return <span key={`NIC-${nicOutcome.value}`} className="tw-flex tw-items-center tw-gap-1.5"><FontAwesomeIcon icon={faAddressCard} className="tw-size-3.5 tw-text-blue-300/70 tw-mt-1" /><span className="tw-text-sm tw-font-normal tw-text-iron-50">NIC</span><span className="tw-text-sm tw-font-normal tw-text-blue-200/90">{formatNumberWithCommas(nicOutcome.value)}</span></span>;
}
function _temp6(award_4) {
  return {
    type: ApiWaveOutcomeType.Manual as const,
    description: award_4.description ?? ""
  };
}
function _temp5(award_3) {
  return award_3.type === ApiWaveOutcomeType.Manual && award_3.description;
}
function _temp4(award_2) {
  return {
    type: ApiWaveOutcomeCredit.Rep as const,
    value: award_2.amount ?? 0,
    category: award_2.rep_category ?? ""
  };
}
function _temp3(award_1) {
  return award_1.credit === ApiWaveOutcomeCredit.Rep && award_1.amount && award_1.amount > 0;
}
function _temp2(award_0) {
  return {
    type: ApiWaveOutcomeCredit.Cic as const,
    value: award_0.amount ?? 0
  };
}
function _temp(award) {
  return award.credit === ApiWaveOutcomeCredit.Cic && award.amount && award.amount > 0;
}